import resolveV2 from '@/endpoints/resolverV2';

import DataResponse from '../../types';

type UserResponse = {
  username: string;
  id: number; // Django id
  active_organization: {
    id: number; // Django org id
    name: string;
    seats: number;
    slug: string;
    permissions: {
      can_access_timber: boolean;
      can_contribute_comps: boolean;
      can_curate_comps: boolean;
    };
    quotas: {
      'insights-reports': {
        count: number;
        limit: number | null;
      };
      savedselection: {
        count: number;
        limit: number | null;
      };
    };
  };
};

export default async function getUser(
  userId: number,
  abortSignal?: AbortSignal
): Promise<DataResponse<UserResponse>> {
  return resolveV2(
    {
      method: 'GET',
      signal: abortSignal,
      url: `/users/${userId}/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
